import { createThunk } from '@app/store/thunk'

import { updateAnnouncementResponsesSlice } from './announcement_responses'
import { updateAnnouncementsSlice } from './announcements'
import { updateEntitiesSlice } from './entities'
import { updateRegionsSlice } from './regions'
import { updateRequestsSlice } from './requests_models'
import { updateUserMetaTagsSlice } from './user_meta_tags'
import { updateUsersFromResponseSlice } from './users'

/**
 * Every api response passes through here: each fold takes what it recognises out of the payload
 * and leaves the rest alone. Lives apart from the slices it calls so that none of them has to
 * import the others.
 */
export const updateFromResponseSlice = (payload: unknown) =>
  createThunk(dispatch => {
    dispatch(updateEntitiesSlice(payload))
    dispatch(updateRegionsSlice(payload))
    dispatch(updateUserMetaTagsSlice(payload))
    dispatch(updateUsersFromResponseSlice(payload))
    dispatch(updateAnnouncementsSlice(payload))
    dispatch(updateAnnouncementResponsesSlice(payload))
    dispatch(updateRequestsSlice(payload))
  })
